import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Sidebar as VoltSidebar } from "@volt_developers/react-ui-components";

import { useMenu } from "../hooks/menu";
// import { useOperationState } from "../hooks/operationsState";
import { selectEnvironment, toggleEnvironment } from "../store/appSlice";
import { ENV_PRODUCTION } from "../constants/environment";
import { useAbility } from "@casl/react";
import { AbilityContext } from "../context/Ability.context";
import appRoutes from "../routes/index";

const Sidebar = () => {
  const ability = useAbility(AbilityContext);
  const { menu } = useMenu(appRoutes, ability);
  /*const { operationLoading } = useOperationState("users.current", {
    defaultLoading: true,
  });*/
  const location = useLocation();
  const dispatch = useDispatch();
  const appEnvironment = useSelector(selectEnvironment);
  const toggle = useCallback(() => {
    dispatch(toggleEnvironment());
  }, [dispatch]);

  return (
    <VoltSidebar
      links={menu}
      isLoading={false} //operationLoading}
      tooltipText={
        appEnvironment === ENV_PRODUCTION
          ? "You are in PRODUCTION mode. All data and transactions you see are live. Switch to SANDBOX mode to see your own test payments and configs."
          : "You are in SANDBOX mode. All data and configs you see are from your own testing. Switch to PRODUCTION mode to see how your shoppers are doing."
      }
      currentPage={location.pathname}
      runsInProduction={appEnvironment === ENV_PRODUCTION}
      onEnvironmentChange={toggle}
      data-testid="layout-sidebar"
    />
  );
};

export default Sidebar;
